import { FormRadioInput } from '@/core/components/FormRadioInput';
import {
  OptInOptions,
} from '@/core/interfaces/common';

import { FormRadioInputWrapper } from '@/themes/globalStyles';

interface OptCheckboxesProps {
  backgroundColor: string;
  isOptInEmail: boolean;
  isOptInText: boolean;
  handleOptChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  organizationName: string;
  optIn: OptInOptions;
}

export const OptCheckboxes = ({
  backgroundColor,
  isOptInEmail,
  isOptInText,
  handleOptChange,
  organizationName,
  optIn,
}: OptCheckboxesProps) => {
  if (optIn.defaultOptIn === true) {
    return (
      <div className="muster-optin">
        <p>
          By submitting this form, you agree to receive future communications from us.
          You can unsubscribe at any time by following the opt-out instructions provided
          in subsequent communications.
        </p>
        <p>
          If you have already unsubscribed, submitting this form will not resubscribe you.
        </p>
      </div>
    );
  }

  if (optIn.defaultOptIn === false) {
    return (
      <div className="muster-optin">
        By submitting this form, you will not be opted in to receive further communications from us.
      </div>
    );
  }

  const defaultEmailOptin = `Yes, opt-in to email updates from ${organizationName}`;
  const defaultTextOptin = `Yes, opt-in to occasional SMS updates from ${organizationName}`;

  return (
    <div
      className="muster-optin"
      style={{
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '450px',
      }}
    >
      <FormRadioInputWrapper>
        <FormRadioInput
          checked={isOptInEmail}
          color={backgroundColor}
          label={optIn.emailCheckboxText || defaultEmailOptin}
          name="isOptInEmail"
          onChange={handleOptChange}
        />
      </FormRadioInputWrapper>
      <FormRadioInputWrapper>
        <FormRadioInput
          checked={isOptInText}
          color={backgroundColor}
          label={optIn.textCheckboxText || defaultTextOptin}
          name="isOptInText"
          onChange={handleOptChange}
        />

        {optIn.defaultOptIn !== false && (
          <p style={{ paddingLeft: '40px' }}>
            Message & data rates may apply. Reply STOP to unsubscribe at any time.
          </p>
        )}
      </FormRadioInputWrapper>
    </div>
  );
};
